export default {
  siteCode: 'Site Code',
  siteName: 'Site Name',
  siteType: 'Site Type',
  siteType2: 'Label Site Type',
  pe: 'PE',
  cancel: 'Cancel',
  reActivate: 'Re-activate',
  errorcode_1: 'Please complete all required fields before creating a new site.',
  errorcode_6000: 'The Site code already exists. Please search for it on the page before making any edits or updates.',
  enableTip: 'Are you sure to remove permission from the selected site(s)?',
  disabledTip: 'Are you sure to re-enable permission from the selected site(s)?'
}
